/* Shopify's dynamic checkout button renders its own "Buy it now" text; relabel it to "Buy now". */
(function () {
  var OLD = /^\s*buy it now\s*$/i;
  var NEW = 'Buy now';

  function relabel(root) {
    var buttons = root.querySelectorAll('.shopify-payment-button__button--unbranded');
    buttons.forEach(function (btn) {
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (OLD.test(node.nodeValue)) node.nodeValue = NEW;
      }
    });
  }

  function init() {
    relabel(document);
    new MutationObserver(function () { relabel(document); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
